import { useMemo } from 'react';

import type { TypingContextValue } from '../../../context/TypingContext';
import type { DefaultBeloChatGenerics } from '../../../types/types';

export const useCreateTypingContext = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  value: TypingContextValue<BeloChatGenerics>,
) => {
  const { typing } = value;

  const typingValue = Object.keys(typing || {}).join();

  const typingContext: TypingContextValue<BeloChatGenerics> = useMemo(
    () => ({
      typing,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [typingValue],
  );

  return typingContext;
};
